<template>
  <div
    class="comp-container"
    :class="{
      'pad-comp-container': isMGAppInPad,
    }"
  >
    <div class="left">
      <div class="lesson-info-wrap">
        <div class="left-wrap">
          <p class="lesson-name">{{ liveReport.lesson_name }}</p>
          <p class="time-wrap">
            <span class="time">
              {{ handleLiveRange }}
            </span>
            <span class="duration">{{ handleLiveDuration }}</span>
          </p>
        </div>
        <button v-if="!isHXApp" @click="jumpCourseDetail" class="operate-btn">
          查看课程回放
        </button>
      </div>
      <div class="live-heat">
        <div class="title">
          <img src="../../../assets/images/live-data/live.png" alt="" />
          <p>直播数据</p>
        </div>
        <ul
          class="data-wrap"
          :class="{ 'small-course-data-wrap': liveReport.course_type === 2 }"
        >
          <li class="data-item">
            <div>
              <p class="data">{{ liveReport.live_num }}</p>
              <p class="data-name">直播参与人数</p>
            </div>
          </li>
          <li class="data-item center">
            <div>
              <p class="data">{{ liveReport.live_peak_num }}</p>
              <p class="data-name">直播峰值人数</p>
            </div>
          </li>
          <!-- 小班课不显示此项数据 -->
          <li v-if="liveReport.course_type === 1" class="data-item">
            <p class="data">{{ liveReport.live_mic_num }}</p>
            <p class="data-name">直播上台次数</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="echarts-wrap right">
      <div id="viewers-num-echarts"></div>
    </div>
  </div>
</template>

<script>
import { isHXApp, isMGAppInPad } from "@saas/components/src";
import moment from "moment";
import { getDurationByStartEndTime } from "@saas/components/src/utils/utils";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from "echarts/charts";
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
} from "echarts/components";
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LineChart,
]);

export default {
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      moment,
      showPageCont: true,
      isElectron: window.isElectron,
      isHXApp: false,
      isMGAppInPad: isMGAppInPad(),
    };
  },
  watch: {
    liveReport: {
      handler(val) {
        if (val) {
          if (this.myChart) {
            this.setOptions();
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    handleLiveRange() {
      return `${moment(this.liveReport.room_start_time * 1000).format(
        "YYYY-MM-DD HH:mm"
      )}-${moment(this.liveReport.room_end_time * 1000).format("HH:mm")}`;
    },
    handleLiveDuration() {
      let { room_start_time, room_end_time } = this.liveReport;
      // let time = room_end_time - room_start_time;
      // // this.liveReport.liveDuration = duration;
      let {
        hours = 0,
        minutes = 0,
        second = 0,
      } = getDurationByStartEndTime(room_start_time, room_end_time);
      let str = "共计";
      if (hours > 0) {
        str += ` ${hours} 时`;
      }
      str += ` ${minutes} 分 ${second} 秒`;
      return str;
    },
  },
  mounted() {
    this.isHXApp = isHXApp();
    this.initEcharts();
  },
  methods: {
    jumpCourseDetail() {
      let { course_id, lesson_id, unit_id } = this.liveReport;
      // let url = `/course-detail/${course_id}?lesson_id=${lesson_id}`;
      let url = `/video-play/${course_id}/${unit_id}/${lesson_id}`;

      if (window.isElectron) {
        // this.$router.push(`/learning-center${url}`);
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    initEcharts() {
      this.myChart = echarts.init(
        document.getElementById("viewers-num-echarts")
      );
      // this.setOptions();
      //   window.addEventListener("resize", this.resize);
    },
    setOptions() {
      var options = {
        tooltip: {
          trigger: "axis",
          borderWidth: 0,
          backgroundColor: "transparent", // 提示框浮层的背景颜色
          borderColor: "transparent",
          padding: 0, // 提示框浮层内边距，单位px
          z: 1000,
          extraCssText:
            "z-index: 999;box-shadow: none;width: 150px;height: 72px;border-radius: 6px;background: linear-gradient( 347deg, #FDFEFF 0%, #F4F7FC 100%);padding: 10px 8px 0 8px;",
          // textStyle: {
          //   width: 300,
          //   height: 900,
          //   lineHeight: 24,
          //   color: "green",
          //   fontSize: "14",
          // },
          formatter: (params) => {
            let param = params[0] || {};
            let [time = "", number = 0] = param?.data || [];
            return `
            <div style="">
                <p style="font-size: 12px;color: #5d6481;line-height: 17px;margin-bottom: 5px;margin-left: 9px;">${time}</p>
                <p style="height: 32px;background: rgba(255, 255, 255, 0.8);border-radius: 4px;display: flex;align-items: center;padding-left: 9px;">
                    <span style="font-size: 12px;color: #5d6481;line-height: 17px;margin-right: 20px;">参与人数</span>
                    <span style=" font-weight: 500; font-size: 12px;color: #0d1400;line-height: 17px;">${number}</span>
                </p>
            </div>`;
          },
        },
        xAxis: {
          type: "time",
          // 设置时间间隔为秒级
          axisLabel: {
            formatter: {},
            //x轴文字的配置
            show: true,
            rotate: 45, // 设置文字旋转45度
            textStyle: {
              color: "#5D6481",
            },
            // interval: 5, //主要设置其间隔，间隔为3
          },
          boundaryGap: false,
          axisLine: {
            //x轴线的颜色以及宽度
            show: true,
            lineStyle: {
              color: "#F5F6F9",
            },
          },
          // axisLabel: {

          // },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(229, 232, 239, 0.40)",
            },
          },
          axisTick: {
            show: false,
          },
          splitNumber: 6,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#5D6481",
            },
          },
        },
        series: [
          {
            // data: [20, 32, 91, 94, 129, 133, 132],
            data: (this.liveReport.live_num_statistics_list || []).map(
              (item) => {
                return [
                  moment(item.date * 1000).format("YYYY-MM-DD HH:mm:ss"),
                  item.number,
                ];
              }
            ),
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0, // 0, 0, 0, 1 代表右/下/左/上
                [
                  { offset: 0, color: "rgba(30, 231, 255, 1)" },
                  { offset: 0.5, color: "rgba(36, 154, 255, 1)" },
                  { offset: 1, color: "rgba(111, 66, 251, 1)" },
                ]
              ),
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, // 0, 0, 0, 1 代表右/下/左/上
                  [
                    { offset: 0, color: "rgba(17, 126, 255, 0.16)" },
                    { offset: 1, color: "rgba(17, 128, 255, 0)" },
                  ]
                ),
              },
            },
            symbolSize: 9,
          },
        ],
        grid: {
          x: 60,
          y: 30,
          x2: 35,
          y2: 68,
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#4080FF", // 线的颜色
            width: 2, // 线的宽度
            type: "dotted", // 线的类型
          },
        },
      };
      this.myChart.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
$page-header-height: 70px;
.comp-container {
  width: 1200px;
  // height: 310px;
  background: var(--live-data-card-bg, #ffffff);
  border: 1px solid var(--live-data-border, transparent);
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  .left,
  .right {
    flex: 1;
    overflow: hidden;
  }
  .right {
    margin-left: 20px;
  }
  .lesson-info-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .left-wrap {
      flex: 1;
      width: 0;
      .lesson-name {
        font-weight: 600;
        font-size: 20px;
        color: var(--live-data-primary, #000000);
        line-height: 28px;
        margin-bottom: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .time {
        font-weight: 400;
        font-size: 16px;
        color: var(--live-data-secondary, #515350);
        line-height: 22px;
      }
      .duration {
        font-weight: 400;
        font-size: 16px;
        margin-left: 40px;
        font-size: 16px;
        color: var(--live-data-secondary, #515350);
        line-height: 22px;
      }
    }
    .operate-btn {
      margin-left: 20px;
      width: 136px;
      height: 50px;
      border-radius: 12px;
      border: 1px solid rgba(0, 232, 132, 0.2);

      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      background: linear-gradient(
        41.94400710581127deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .live-heat {
    width: 570px;
    height: 184px;
    background: var(--live-data-surface-bg, #f7f8fa);
    border-radius: 18px 18px 18px 18px;
    border: 1px solid var(--live-data-border, #f2f3f5);
    margin: 0 auto;
    padding: 0;
    // margin: 0 auto 20px;
    .title {
      display: flex;
      align-items: center;
      margin-left: 20px;
      padding-top: 24px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        margin-left: 8px;
        font-weight: 500;
        font-size: 16px;
        color: var(--live-data-primary, #0d1400);
      }
    }
    .data-wrap {
      display: flex;
      margin-top: 32px;
    }
    .data-wrap.small-course-data-wrap {
      display: flex;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
      }
    }
    .data-item {
      position: relative;
      padding-left: 49px !important;
      width: 200px;
      &:first-child {
        padding-left: 24px !important;
        width: 172px;
      }
      .data.course-name {
        height: 56px;
        font-weight: 600;
        font-size: 20px;
        color: var(--live-data-primary, #0d1400);
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .data {
        font-weight: bold;
        font-size: 36px;
        color: var(--live-data-primary, #0d1400);
        line-height: 42px;
        margin-bottom: 8px;
      }
      ::v-deep .sell-amount {
        padding-top: 14px;
        font-weight: bold;
        color: #f03349;
        .symbol {
          font-weight: 600;
          font-size: 19px;
          line-height: 26px;
        }
        .integer {
          font-size: 36px;
          line-height: 42px;
        }
        .decimal {
          font-size: 24px;
          line-height: 28px;
        }
      }
      .data-name {
        font-weight: 400;
        font-size: 16px;
        color: var(--live-data-secondary, #515350);
        line-height: 22px;
      }
      &::after {
        position: absolute;
        right: 0;
        top: 3px;
        display: block;
        content: "";
        width: 1px;
        height: 64px;
        margin-left: 50px;
        background: linear-gradient(
          180deg,
          rgba(244, 244, 247, 0) 0%,
          #f2f2f5 14%,
          #e7e8ec 89%,
          rgba(229, 230, 235, 0) 100%
        );
      }
      &:last-child::after {
        display: none;
      }
      &.center {
        display: flex;
        flex-direction: column;
      }
    }
  }

  .sell-data-wrap.data-wrap .data {
    height: 56px;
  }

  #viewers-num-echarts {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}
.pad-comp-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 620px;
  min-height: 620px;
  .right,
  .left {
    height: 50%;
    margin: 0;
  }
  #viewers-num-echarts {
    height: 310px;
  }
}
</style>
